import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  // 师范类导入
  uploadRelative({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/relativeManagement/uploadRelative`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 师范类导出
  downloadRelative({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/relativeManagement/downloadRelative`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 导入
  importExcel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/relativeManagement/importExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导出
  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/relativeManagement/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
